import React from 'react';
import SecondaryPage from 'challenge/common/KnowledgeComponents/SecondaryPage/Desktop';
import { TextWrapper, Title, Text } from './elements';

type Props = {
  readonly className?: string;
  readonly buttonText: string;
  readonly title: string;
  readonly text: string;
  readonly backOnClick: () => void;
};

function InfoPage({
  className,
  buttonText,
  title,
  text,
  backOnClick,
}: Props): React.ReactElement {
  return (
    <SecondaryPage
      className={className}
      backOnClick={backOnClick}
      buttonText={buttonText}
    >
      <TextWrapper>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </TextWrapper>
    </SecondaryPage>
  );
}

export default InfoPage;
